'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CloudUploadOutlined = _interopRequireDefault(require('./lib/icons/CloudUploadOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CloudUploadOutlined;
exports.default = _default;
module.exports = _default;